import { gettext } from '../translation'

/**
 * add hints for testing in DEBUG
 */
export function addTestingHints() {
	emailInputHints()
}

/**
 * add hints for email-inputs
 */
function emailInputHints() {
	document
		.querySelectorAll('input[type="email"]')
		.forEach(function (emailInput) {
			const emailHintSpan = document.createElement('span')
			emailHintSpan.innerHTML =
				'<i class="far fa-exclamation-triangle text-danger"></i>&nbsp;' +
				gettext(
					'Wenn du den E-Mail-Verand über diese E-Mail-Adresse testest, setze USE_REAL_EMAIL_ADDRESSES=True und nutze eine echte E-Mail-Adresse die auch dir gehört. Prüfe gegebenfalls die Empfänger im E-Mail-Protokoll!'
				)
			emailHintSpan.classList.add('emailTestinHint', 'form-text', 'text-danger')
			emailHintSpan.role = 'alert'
			emailInput.insertAdjacentElement('afterend', emailHintSpan)
		})
}
